import 'firebase/storage';
import 'firebase/auth';

import firebase from 'firebase/app';

import { $http, Constants } from '@/store/actions/constants';

import appAuth from '../../plugins/auth';

export const firebaseActions = {

    updateUserInfo: ({ commit }, data) => {
        return appAuth.currentUser.updateProfile({ displayName: data.displayName }).then(() => {
            commit('SET_USERINFO_DISPLAY_NAME', data.displayName);
        });
    },
    getUserToken: ({ commit }) => {
        return appAuth.currentUser.getIdTokenResult(true).then(res => {
            if (res.claims && res.claims.email_verified) {
                commit('ADD_USERINFO', {
                    token: res.token,
                    uid: res.claims.sub,
                    role: res.claims.role,
                    email: res.claims.email,
                    username: appAuth.currentUser.displayName,
                    userID: res.claims.userID,
                    namespace: res.claims.namespace,
                    companyID: res.claims.companyID,
                    email_verified: res.claims.email_verified
                });
                commit('SET_LOGIN_STATE', true);
                commit('SET_AUTH_HEADER', res.token);
            } else {
                commit('SET_LOGIN_STATE', false);
            }
        }).catch(e => {
            console.error(e);
            commit('SET_LOGIN_STATE', false);
        });
    },

    logoutCurrentUser: ({ commit }) => {
        return appAuth.signOut().then(() => commit('SET_LOGIN_STATE', false));
    },

    loginUser: ({ }, credentials) => {
        return appAuth.signInWithEmailAndPassword(credentials.email, credentials.password);
    },

    sendSignInEmail: ({ }, payload) => {
        return appAuth.sendSignInLinkToEmail(payload.email, {
            handleCodeInApp: true,
            url: `${Constants.BaseURL}/auth/activate?email=${payload.email}&companyID=${payload.companyID}&namespace=${payload.namespace}`,
        });
    },

    sendInvite: ({ _, state }, payload) => {
        let url = `${Constants.BaseURL}/employee/${payload.id}/activate`;
        return $http.post(url, {}, state.authHeader)//then(res => {
        // if (res.status === 200) {
        //     const activationURL = `${Constants.BaseURL}/auth/activate?email=${payload.email}&companyID=${payload.companyID}&namespace=${payload.namespace}`;
        //     return firebase.auth().sendPasswordResetEmail(payload.email, { handleCodeInApp: false, url: activationURL });
        // }
        // });
    },

    sendResetEmail: ({ }, email) => {
        return appAuth.sendPasswordResetEmail(email, { handleCodeInApp: false, url: Constants.FrontendURL });
    },

    uploadPrivateDocuments: ({ }, data) => {
        return firebase.storage().ref(data.fileName).put(data.content, data.metadata);
    },

    uploadImage({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            firebase.storage().ref(data.fileName).put(data.content, data.metadata).then(snapshot => {
                snapshot.ref.getDownloadURL().then(r => {
                    let payload = Constants.getPayloadByAction(data, r); //returns the right data depending on the action
                    resolve(dispatch(data.action, payload));
                }).catch(err => {
                    reject(err);
                });
            });
        });
    },

    resetPassword: ({ state }, data) => {
        return appAuth.confirmPasswordReset(data.oobCode, data.password)
    }
};
